import React from "react";
import gif from "../../images/loading.gif";
/**
 * @param {*} props
 * @param {string} props.styleName
 */
export default class Loading extends React.Component {
  render() {
    return (
      <div className="loading">
        <img src={gif} />
        <p>Cargando...</p>
      </div>
    );
  }
}
